// eslint-disable-next-line max-classes-per-file
import Base, { ErrorBase } from 'requests/objects/_base'
import Company from 'requests/objects/company'

/**
 * VacationWeek Object
 */
export default class VacationWeek extends Base {
    /**
     * @param {object} data data
     * @param {number=} data.vacationWeekId vacationWeekId
     * @param {number=} data.year year
     * @param {number=} data.week week
     * @param {number=} data.companyId companyId
     * @param {object=} data.company company
     */
    constructor({
        vacationWeekId = 0,
        year = 0,
        week = 0,
        companyId = 0,
        company,
        ...data
    } = {}) {
        super(data)
        this.vacationWeekId = vacationWeekId
        this.year = year
        this.week = week
        this.companyId = companyId
        this.company = company ? new Company(company) : null
    }
}

/**
 * User Object used to bind error message
 */
export class ErrorVacationWeek extends ErrorBase {
    constructor() {
        super()
        this.vacationWeekId = ''
        this.year = ''
        this.week = ''
        this.companyId = ''
    }
}
